import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import InputSearchReports from "./InputSearchReports"
import FilterOrdersCheckbox from "../orders/FilterOrdersCheckbox"
import { checkRole, removeEmptyObject } from "../../services/help"
import { IoMdCloseCircle, IoMdRefresh } from "react-icons/io"
import FilterReportDate from "./FilterReportsDate"
import FilterReportsSort from "./FilterReportsSort"
import useAuth from "../../hooks/useAuth"
import FilterReportUserChoose from "./FilterReportUserChoose"
import MoreFiltersBox from "./MoreFiltersBox"
import FilterReportPublishDate from "./FilterReportPublishDate"
import FilterReportAge from "./FilterReportAge"
import FilterReportCategories from "./FilterReportCategories"
import { FiPlus } from "react-icons/fi"
import ComparisonBoxFilter from "./ComparisonBoxFilter"
import FilterReportSecoundCategories from "./FilterReportSecoundCategories"
import TitleBarReportPage from "./TitleBarReportPage"


const FilterReports = ({ showDetails, setDataChart }) => {

    const { auth } = useAuth()
    const isAdmin = checkRole(auth, ['ADMIN'])

    const [searchParams, setSearchParams] = useSearchParams()
    const defdateValFrom = searchParams.get('regDateFrom')
    const defdateValTo = searchParams.get('regDateTo')

    const [dateFrom, setDateFrom] = useState(defdateValFrom)
    const [dateTo, setDateTo] = useState(defdateValTo)

    const [chartFilterValues, setChartFilterValues] = useState()
    const [filtersValue, setFiltersValue] = useState()

    const [titleFilters, setTitleFilters] = useState()
    const [titleSort, setTitleSort] = useState()

    const [dateSelect, setDateSelect] = useState(
        (defdateValFrom || defdateValTo) ? '3' :
            searchParams.get('dateType') ? searchParams.get('dateType') : 1
    )
    const [reportSort, setReportSort] = useState(searchParams.get('sortType') ? searchParams.get('sortType') : '0')
    const [searchQuery, setSearchQuery] = useState(searchParams.get('searchTerm') ? searchParams.get('searchTerm') : '')

    const [queries, setQueries] = useState({})
    const [moreFilterBox, setMoreFilterBox] = useState()

    const [checkboxDefVal, setCheckboxDefVal] = useState(true)
    const [comparisonBoxShow, setComparisonBoxShow] = useState(false)

    const handleClickComparisonBtn = () => {
        setComparisonBoxShow(!comparisonBoxShow)
        setMoreFilterBox()
    }



    useEffect(() => showDetails(checkboxDefVal), [checkboxDefVal])

    useEffect(() => {
        setMoreFilterBox()
        setFiltersValue()
        setChartFilterValues()
    }, [dateFrom, dateTo, dateSelect, reportSort, searchQuery])

    useEffect(() => {
        setQueries(removeEmptyObject({
            regDateFrom: dateFrom && dateSelect === '3' ? dateFrom : null,
            regDateTo: dateTo && dateSelect === '3' ? dateTo : null,
            sortType: parseInt(reportSort),
            dateType: dateSelect && dateSelect !== '3' ? parseInt(dateSelect) : null,
        }))
    }, [dateFrom, dateTo, dateSelect, reportSort])

    //set query to buttons
    useEffect(() => {
        setFiltersValue(removeEmptyObject({
            filterUserId: searchParams.get('filterUserId') ? { value: searchParams.get('filterUserId'), name: searchParams.get('filterUserId') } : '',
            primarySubjectCategoryId: searchParams.get('primarySubjectCategoryId') ? { value: searchParams.get('primarySubjectCategoryId'), name: searchParams.get('primarySubjectCategoryId') } : '',
            secondarySubjectCategoryId: searchParams.get('secondarySubjectCategoryId') ? { value: searchParams.get('secondarySubjectCategoryId'), name: searchParams.get('secondarySubjectCategoryId') } : '',
            ages: searchParams.get('ages') ? { value: searchParams.get('ages'), name: searchParams.get('ages') } : '',
            publishDate: searchParams.get('productionYear') ? { value: searchParams.get('productionYear'), name: searchParams.get('productionYear') } : ''
        }))

        setTitleFilters(removeEmptyObject({
            filterUserId: searchParams.get('filterUserId') ? { value: searchParams.get('filterUserId'), name: searchParams.get('filterUserId') } : '',
            primarySubjectCategoryId: searchParams.get('primarySubjectCategoryId') ? { value: searchParams.get('primarySubjectCategoryId'), name: searchParams.get('primarySubjectCategoryId') } : '',
            secondarySubjectCategoryId: searchParams.get('secondarySubjectCategoryId') ? { value: searchParams.get('secondarySubjectCategoryId'), name: searchParams.get('secondarySubjectCategoryId') } : '',
            ages: searchParams.get('ages') ? { value: searchParams.get('ages'), name: searchParams.get('ages') } : '',
            publishDate: searchParams.get('productionYear') ? { value: searchParams.get('productionYear'), name: searchParams.get('productionYear') } : ''
        }))

        setTitleSort(removeEmptyObject({
            regDateFrom: searchParams.get('regDateFrom') ? searchParams.get('regDateFrom') : null,
            regDateTo: searchParams.get('regDateTo') ? searchParams.get('regDateTo') : null,
            sortType: searchParams.get('sortType') ? searchParams.get('sortType') : null,
            dateType: searchParams.get('dateType') ? searchParams.get('dateType') : null,
        }))

    }, [])

    const handleSubmitForm = (event) => {
        event.preventDefault()

        setTitleFilters(filtersValue)
        setTitleSort(removeEmptyObject({
            regDateFrom: dateFrom && dateSelect === '3' ? dateFrom : null,
            regDateTo: dateTo && dateSelect === '3' ? dateTo : null,
            sortType: reportSort,
            dateType: dateSelect && dateSelect !== '3' ? dateSelect : null,
        }))

        setSearchParams(removeEmptyObject({
            searchTerm: searchQuery ? searchQuery : null,
            regDateFrom: dateFrom && dateSelect === '3' ? dateFrom : null,
            regDateTo: dateTo && dateSelect === '3' ? dateTo : null,
            sortType: reportSort,
            dateType: dateSelect && dateSelect !== '3' ? dateSelect : null,
            //more filters
            filterUserId: filtersValue?.filterUserId?.value ? filtersValue.filterUserId.value : null,
            primarySubjectCategoryId: filtersValue?.primarySubjectCategoryId?.value ? filtersValue.primarySubjectCategoryId.value : null,
            secondarySubjectCategoryId: filtersValue?.secondarySubjectCategoryId?.value ? filtersValue.secondarySubjectCategoryId.value : null,
            ages: filtersValue?.ages?.value ? filtersValue.ages.value : null,
            productionYear: filtersValue?.publishDate?.value ? filtersValue.publishDate.value : null
        }))
    }

    const handleResetForm = () => {

        setSearchParams({})
        showDetails(true)
        setCheckboxDefVal(true)
        //
        setSearchQuery('')
        setReportSort('0')
        setDateSelect('0')
        setFiltersValue()
        setChartFilterValues({})
        setMoreFilterBox()
        setComparisonBoxShow(false)

        setTitleFilters()
        setTitleSort({})
    }


    return (<>
        <style>
            {`
            #theChart{display:${comparisonBoxShow ? 'block' : 'none'}}
            .theTable{display:${comparisonBoxShow ? 'none' : 'block'}}
           ${comparisonBoxShow ? '.xdfe633{opacity: .5; pointer-events: none;}' : ''}
           #topTitle,#bottomTitle{display:${comparisonBoxShow ? 'flex' : 'none'}}
            `}
        </style>

        <div>
            <form onSubmit={handleSubmitForm} style={{ position: 'relative', zIndex: 999 }}>
                <InputSearchReports pullback={setSearchQuery} defaultValue={searchQuery} />
                <div className='fh'>
                    <div className='filterItems'>
                        <FilterReportsSort reportSort={setReportSort} defaultValue={reportSort} />
                        <FilterReportDate dateValFrom={setDateFrom} dateValTo={setDateTo} defaultdateValFrom={defdateValFrom} defaultdateValTo={defdateValTo} dateSelect={setDateSelect} defaultSelectedDate={dateSelect} />
                        <FilterOrdersCheckbox pullback={setCheckboxDefVal} defaultValue={checkboxDefVal} />
                        <div className="flex" style={{ gap: 10 }}>
                            <button type="submit" className="xdfe633" style={{ height: '38px', paddingTop: '9px' }}>نمایش نتایج</button>
                            <button style={{ height: '38px', paddingTop: '9px', minWidth: 'fit-content', fontSize: '20px', lineHeight: 0, background: '#95a3b3', border: 'none' }} type='button' onClick={handleResetForm}><IoMdRefresh /></button>
                        </div>
                    </div>
                </div>

                <div className='fh'>
                    <div className='filterItems'>
                        <span className="ttt">
                            افـزودن فیـلتر هـای بیشتـر
                            <button type="button" className="comparisonBtn" onClick={handleClickComparisonBtn}>
                                {comparisonBoxShow ? <IoMdCloseCircle /> : <FiPlus />} مقایسه
                            </button>
                        </span>


                        {isAdmin && <FilterReportUserChoose queries={queries} setData={setMoreFilterBox} active={filtersValue} />}

                        <FilterReportPublishDate queries={queries} setData={setMoreFilterBox} active={filtersValue} />
                        <FilterReportAge queries={queries} setData={setMoreFilterBox} active={filtersValue} />
                        <FilterReportCategories queries={queries} setData={setMoreFilterBox} active={filtersValue} />
                        <FilterReportSecoundCategories queries={queries} setData={setMoreFilterBox} active={filtersValue} />

                    </div>
                </div>

            </form>

            {comparisonBoxShow && <ComparisonBoxFilter chartValues={chartFilterValues} baseFilterValues={filtersValue} isAdmin={isAdmin} queries={queries} setData={setMoreFilterBox} setDataChart={setDataChart} />}
            <hr style={{ borderColor: '#cdcdcd', opacity: 1, margin: '25px 0 0' }} />
            <MoreFiltersBox data={moreFilterBox} queries={queries} setValues={setFiltersValue} values={filtersValue} setChartValues={setChartFilterValues} chartValues={chartFilterValues} />

        </div>


        {!comparisonBoxShow && <TitleBarReportPage filters={titleFilters} sort={titleSort} />}


    </>);
}

export default FilterReports;